(function() {
    const archiveEl = document.querySelector('.jsTrainingTeacherArchive');

    let trainingGrid = null;
    let trainersGrid = null;

    let searchTimeout = null;
    let searchQuery = '';

    if (archiveEl) {
        trainingGrid = archiveEl.querySelector('.jsTrainingGrid');
        trainersGrid = archiveEl.querySelector('.jsTrainersGrid');

        const teachingTypeFilterEl = archiveEl.querySelector('.jsTeachingTypeFilter');
        if (teachingTypeFilterEl) {
            const teachingTypeSelect = new SeSelect(teachingTypeFilterEl, 'teaching-type');
            teachingTypeSelect.setActiveOptions(activeTeachingTypes);

            teachingTypeSelect.addChangeEventListener(newOptions => {
                activeTeachingTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            const typeSelect = new SeSelect(typeFilterEl, 'education-type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(newOptions => {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const regionFilterEl = archiveEl.querySelector('.jsRegionFilter');
        if (regionFilterEl) {
            const regionSelect = new SeSelect(regionFilterEl, 'region');
            regionSelect.setActiveOptions(activeRegions);

            regionSelect.addChangeEventListener(newOptions => {
                activeRegions = Object.keys(newOptions);
                updateGrid();
            });
        }
    }

    function updateGrid() {

        // trainingGrid
        // trainersGrid

        const params = {
            action: 'get_teachers_trainers_grid_html',
            activeTeachingTypes: activeTeachingTypes,
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeRegions: activeRegions,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                trainingGrid.innerHTML = response.html_trainingen;
                trainersGrid.innerHTML = response.html_teachers;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }
        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
